import { PdfGeneratorService } from './../../../../../services/pdf-generator.service';
import { EmailPreviewService } from './../../../../../services/email-preview-service';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { HtmlTemplateVar } from '../../../../../dto/templates/html-template-var';
import { HtmlEditorComponent } from '../../../../../shared/html-editor/html-editor.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailTemplate } from '../../../../../dto/templates/email-template';
import { InvoiceEmailTemplatesService } from '../../../../services/invoice-email-templates.service';
import { FileHelper } from '../../../../../helpers/file-helper';
import {GrapesjsEditorComponent} from '../../../../../shared/grapesjs-editor/grapesjs-editor.component';
import {
  EmailTemplatesEditComponentBase
} from '../../order-email-templates/order-email-templates-edit/email-templates-edit-component.base';
import {MatDialog} from '@angular/material/dialog';
import {ToastService} from 'angular-toastify';
import {MyAccountService} from '../../../../../services/my-account.service';
import {AuthUserInfoModel} from '../../../../../models/auth-user-info-model';

@Component({
  selector: 'app-invoice-email-templates-edit',
  templateUrl: './invoice-email-templates-edit.component.html',
  styleUrls: ['./invoice-email-templates-edit.component.css']
})
export class InvoiceEmailTemplatesEditComponent extends EmailTemplatesEditComponentBase implements OnInit {

  commands: HtmlTemplateVar[];

  id: number;

  @ViewChild(HtmlEditorComponent, { static: false }) editor: HtmlEditorComponent;
  private user: AuthUserInfoModel;

  constructor(
    private templatesService: InvoiceEmailTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private pdfGeneratorService: PdfGeneratorService,
    private emailPreviewService: EmailPreviewService,
    private dialog: MatDialog,
    private toastService: ToastService,
    private myAccountService: MyAccountService,
  ) {
    super(templatesService, toastService, dialog);
  }

  templateForm: FormGroup;

  selectedLanguage = 0;
  mjml = '';
  html = '';
  previewHtml = '';
  initmjml = '';

  selectLanguage(lang: number){

    if( Number.isNaN(this.id) ){
      alert('English template must be saved first.');
      return;
    }

    const mjml = this.sharedgjs.editorGJS.getHtml();

    if (this.templateForm.dirty || this.initmjml !== mjml ){
      if(!confirm('Changes not saved. Do you want to proceed?')){
        return;
      }
    }

    this.navigateToLanguage(lang);

  }

  navigateToLanguage(lang: number){
    window.location.href = '/administration/templates/invoice-email/'+this.id+'?lang='+lang;
  }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    const lang = parseInt(this.route.snapshot.queryParamMap.get('lang'));

    this.myAccountService.getCurrentUser().subscribe(result => {
      this.user = result;
    });

    if( Number.isNaN(lang) ){
      this.selectedLanguage = 1;
    }else{
      this.selectedLanguage = lang;
    }

    //alert(this.selectedLanguage);

    if (Number.isNaN(this.id)) {
      this.initForm(new EmailTemplate());
    } else {
      this.templatesService.get(this.id).subscribe(result => {
        // german
        if( this.selectedLanguage === 0 ){
          this.mjml = result.mjml;
          this.html = result.html;
          this.previewHtml = result.previewHtml;
        }
        // english
        else if( this.selectedLanguage === 1 ){
          this.mjml = result.mjmlEn;
          this.html = result.htmlEn;
          this.previewHtml = result.previewHtmlEn;
        }
        else {
          alert('Language not found.');
        }

        this.initmjml = this.mjml;

        this.initForm(result);
      });
    }
  }

  insert(command: string) {
    this.editor.insertHtml(command);
  }

  initForm(template: EmailTemplate) {

    this.templateForm = this.formBuilder.group({
      id: template.id,
      name: template.name,

      subject: template.subject,
      html: template.html,
      mjml: template.mjml,

      subjectEn: template.subjectEn,
      mjmlEn: template.mjmlEn,
      htmlEn: template.htmlEn,

      attachTermsOfService: false,
    });


    this.templatesService.getVars().subscribe(result => {
      this.commands = result.data;
      this.commandsLoaded = true;
    });
  }

  goBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  onSubmit(form: FormGroup) {
    if( form.value.name == '' ){
      alert('Please define a name.');
      return;
    }


    const mjml = this.sharedgjs.editorGJS.getHtml();
    const html = this.sharedgjs.editorGJS.runCommand('mjml-get-code').html;


    // german
    if( this.selectedLanguage === 0 ){
      form.value.html = html;
      form.value.mjml = mjml;
      if( form.value.subject == '' ){
        alert('Please define a subject.');
        return;
      }
    }
    // english
    else if ( this.selectedLanguage === 1 ){
      form.value.htmlEn = html;
      form.value.mjmlEn = mjml;
      if( form.value.subjectEn == '' ){
        alert('Please define a subject.');
        return;
      }
    }
    else {
      alert('Language not found.');
      return;
    }


    if (Number.isNaN(this.id)) {
      this.templatesService.add(form.value).subscribe(res => {
        this.id = res;
        this.navigateToLanguage(this.selectedLanguage);
      });
    } else {
      this.templatesService.update(this.id, form.value).subscribe(res => this.navigateToLanguage(this.selectedLanguage));
    }
  }

  generatePdf() {
    this.pdfGeneratorService.generatePdf(this.templateForm.value).subscribe(result => {
      FileHelper.saveFile(result);
    });
  }

  /* grapesjs */

  sharedgjs: GrapesjsEditorComponent;
  iframeD: ElementRef;

  editorIsInit = false;
  commandsLoaded = false;
  iframeIsSet = false;



  @ViewChild('iframeD', {static: false}) set iframe(iframe: ElementRef) {
    if(iframe) { // initially setter gets called with undefined
      if(this.templateForm.value.html && !this.iframeIsSet) {
        this.iframeIsSet = true;
        this.iframeD = iframe;
        this.iframeD.nativeElement.contentWindow.frames.document.body.insertAdjacentHTML('beforebegin', this.previewHtml);
      }
    }
  }

  @ViewChild('sharedgjs', {static: false}) set gEditor(gEditor: GrapesjsEditorComponent) {
    if(gEditor) { // initially setter gets called with undefined
      this.sharedgjs = gEditor;

      if(!this.editorIsInit) {
this.go();
}
      this.editorIsInit = true;
    }
  }

  saveFromEditor(data){
    this.save();
  }

  save(){


    this.onSubmit(this.templateForm);

  };

  async go(){
    let shouldStop = false;
    while(!shouldStop){

      if(this.editorIsInit && this.commandsLoaded){
        shouldStop = true;
        this.sharedgjs.go();
      }
      await this.delay(500);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  sendPreview() {
    const html = this.sharedgjs.editorGJS.runCommand('mjml-get-code').html;
    super.sendPreviewBase(html, this.selectedLanguage, this.user.userName, this.id);
  }

}
